export default __webpack_public_path__ + "static/media/magic-link-background.445471a1.svg";